let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("eeKhV")).then(() => parcelRequire('fsvOM'));